import { createContext, useContext, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./HomeworksUIHelpers";

const HomeworksUIContext = createContext();

export function useHomeworksUIContext() {
  return useContext(HomeworksUIContext);
}

export const HomeworksUIConsumer = HomeworksUIContext.Consumer;

export function HomeworksUIProvider({ homeworksUIEvents, children }) {
  const { user } = useSelector(state => state.auth);
  initialFilter.term = user.currentActiveTerm; // Mevcut Aktif Dönem Atanıyor
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    openHomeworkDetailPage: homeworksUIEvents.openHomeworkDetailPage
  };

  return (
    <HomeworksUIContext.Provider value={value}>
      {children}
    </HomeworksUIContext.Provider>
  );
}